import { FC, ReactNode } from 'react';
import { DockDirection } from './WbDockableGroup';
import { PrimaryPanelToggleButton } from './WbDockableButtons';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(
  theme => ({
    outer: {
      width: '100%',
      flexShrink: 0,
      containerType: 'inline-size',
    },
    outerBorder: {
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    inner: {
      display: 'flex',
      alignItems: 'center',
      minHeight: 48,
      padding: '8px 6px',
      gap: theme.spacing(1),
      flexWrap: 'wrap',
    },
    title: {
      display: 'flex',
      minWidth: 0,
      flexShrink: 0,
      alignItems: 'center',
    },
    titleText: {
      fontWeight: 500,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    actions: {
      justifyContent: 'flex-end',
      flex: 1,
      display: 'flex',
      alignItems: 'center',
    },
  }),
  { name: 'DockableCardHeader' },
);

interface DockableCardHeaderProps {
  title?: string;
  actions?: ReactNode;
  borderBottom?: boolean;
  toggle?: {
    isCollapsed: boolean;
    direction?: DockDirection;
    position?: 'start' | 'end';
    onToggle: () => void;
  };
  cardHeaderStyles?: React.CSSProperties;
}

export const DockableCardHeader: FC<DockableCardHeaderProps> = ({
  title,
  actions,
  borderBottom,
  toggle,
  cardHeaderStyles,
}) => {
  const isCollapsed = toggle?.isCollapsed ?? false;
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.outer, borderBottom && classes.outerBorder)}
      style={cardHeaderStyles}
    >
      <div className={classes.inner}>
        {toggle && (
          <PrimaryPanelToggleButton
            ariaLabel={
              isCollapsed ? `Expand ${title} panel` : `Collapse ${title} panel`
            }
            expanded={!isCollapsed}
            direction={toggle.direction}
            position={toggle.position}
            onClick={toggle.onToggle}
          />
        )}

        {!isCollapsed && title && (
          <div className={classes.title}>
            <span className={classes.titleText}>{title}</span>
          </div>
        )}

        {!isCollapsed && actions && (
          <div className={clsx(classes.actions)}>{actions}</div>
        )}
      </div>
    </div>
  );
};
